import _ from 'lodash';
import React from 'react';
import {
  Col, FormGroup, FormText, FormFeedback, Label, Input,
} from 'reactstrap';
import { Field as FieldRFF } from 'react-final-form';
import { PropTypes } from '~/utils';

/*
Field properties:
  beforeSubmit
  afterSubmit
  allowNull
  children
  component
  defaultValue
  format
  formatOnBlur
  initialValue
  isEqual
  multiple
  name
  parse
  subscription
  type
  validate
  validateFields
  value
*/

export function FormField( props ) {
  const { id, name, label, help } = props;
  const field = _.pick( props, [
    'type',
  ] );
  return (
    <FormGroup row>
      <Label for={ id || name } sm={2}>{ label || name }</Label>
      <FieldRFF name={ name } id={ id || name }>
        { ( { input, meta } ) => {
          const error = meta.error || meta.submitError;
          const invalid = Boolean( error && meta.touched );
          return (
            <Col sm={10}>
              <Input
                className="focusable"
                {...input}
                {...field}
                invalid={invalid}
              />
              <FormText>{help}</FormText>
              <FormFeedback>{error}</FormFeedback>
            </Col>
          );
        } }
      </FieldRFF>
    </FormGroup>
  );
}
FormField.propTypes = {
  id      : PropTypes.string,
  name    : PropTypes.string.isRequired,
  label   : PropTypes.string,
  help    : PropTypes.string,
};
